import React from 'react';
import Form2 from './form2';

class SearchBar extends React.Component {
    constructor(props){
        super(props);

        this.submit = this.submit.bind(this);
        this.search = this.search.bind(this);
        this.change = this.change.bind(this);
    }

    componentDidMount() {
        this.setSearchProps(this.props.searchValues);
    }

    componentWillReceiveProps(props) {
        this.setSearchProps(props.searchValues);
    }

    submit(event, data){
        event.preventDefault();
        this.search(data);
    }

    search(data) {
        if (this.props.onSearch) {
            this.props.onSearch(data);
        }
    }

    setSearchProps(searchProps = {}) {
        this._formElement.data = searchProps;
    }

    change(event, data) {
        if (this.props.onChange) {
            this.props.onChange(event, data);
        }

        if (this.props.autoSearch) {
            this.search(data);
        }
    }

    render () {

        return (
            <Form2 ref={form => this._formElement = form} {...this.props} onSubmit={(e, data) => this.search(data)} onChange={(e, data) => this.change(e, data)} className={['component-search-bar', 'input-group', this.props.className].join(' ')} onSubmit={this.submit}>
                { this.props.children }
            </Form2>
        )
    }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./web-app/components/search-bar.jsx